import { useAtom } from "jotai";

import {
  showSubitemDrawerAtom,
  subitemDrawerAtom,
} from "../../../atoms/PageAtoms";
import SubitemDrawer from "../../Drawers/Subitems/SubitemDrawer";

const PageViewSubitemDrawer = () => {
  const [subitemDrawer, setSubitemDrawer] = useAtom(subitemDrawerAtom);
  const [showDrawer, setShowDrawer] = useAtom(showSubitemDrawerAtom);

  return (
    showDrawer && (
      <SubitemDrawer
        open={subitemDrawer?.open === true}
        onClose={() => setSubitemDrawer((prev) => ({ ...prev, open: false }))}
        onExited={() => setShowDrawer(false)}
        existingRecord={subitemDrawer?.parentRecord}
        field={subitemDrawer?.field}
        displayMode={subitemDrawer?.displayMode}
        moduleAPIName={subitemDrawer?.moduleAPIName}
        reusableViewReferenceFields={subitemDrawer?.reusableViewReferenceFields}
      />
    )
  );
};

export default PageViewSubitemDrawer;
